import { Toast } from "native-base";

const SuccessToast = (message, title = "Success", placement = "top") => {
	Toast.show({
		title: title,
		description: message,
		status: "success",
		placement: placement,
		backgroundColor: "#62cf6b",
		// duration: 5000,
		duration: null,
	});
};

export default SuccessToast;
